import { z } from 'zod/v3';

export const analyticsEventSchema = z.object({
  event: z.string().min(1, 'event é obrigatório'),
  properties: z.object({
    /** Product feature grouping. Required for new events; optional during migration. */
    feature: z
      .string()
      .min(1)
      .optional(),
    /** Subdivisão dentro da `feature` (ex.: 'Gestão de Prazos'). Opcional. */
    module: z.string().optional(),
    /** @deprecated Prefer `feature`. Optional during migration. */
    category: z.string().optional(),
    event_meaning: z.string().min(1, 'event_meaning é obrigatório'),
    owner: z.string().min(1, 'owner é obrigatório'),
    relevant_user_activity: z.boolean(),
    event_text: z.string().optional(),
    menu_category: z.string().optional(),
    menu_version: z.string().optional(),
    item_name: z.string().optional(),
    category_parent: z
      .string()
      .nullable()
      .optional(),
    target_version: z.string().optional(),
    // boolean going forward (FT-1138); `1` is the legacy numeric value already emitted by Clientes/Drive.
    filtro_hubspot: z.union([z.boolean(), z.literal(1)]).optional(),
  }),
  context: z.object({
    groupId: z.string().min(1, 'context.groupId é obrigatório'),
    library: z.object({
      name: z.string().min(1, 'context.library.name é obrigatório'),
      componente: z.string().min(1, 'context.library.componente é obrigatório'),
    }),
  }),
});
